import { styled, css } from 'styled-components';
import { DropIcon, HelpIcon } from './Usage/Icons';

export const StyledH1 = styled.h1`
  font-family: 'Noto Sans', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  color: #242527;
`;

export const StyledH3 = styled.h3`
  font-size: 18px;
  line-height: 24px;
  font-style: normal;
  font-weight: bold;
  color: #242527;
`;

export const StyledP = styled.p`
  font-family: 'Noto Sans', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #242527;
`;

export const StyledBoldP = styled(StyledP)`
  font-weight: bold;
`;

export const DefaultTextStyle = css`
  color: #42abe9;
  font-family: 'Noto Sans', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
`;
export const DefaultBoldTextStyle = css`
  ${DefaultTextStyle}
  font-weight: bold;
`;
export const PrimaryTextStyle = css`
  ${DefaultTextStyle}
  color: #FFFFFF;
`;
export const PrimaryBoldTextStyle = css`
  ${PrimaryTextStyle}
  font-weight: bold;
`;

export const VioletTextStyle = css`
  ${DefaultTextStyle}
  color: #752FB9;
`;

export const VioletBoldTextStyle = css`
  ${VioletTextStyle}
  font-weight: bold;
`;

export const SmallTextStyle = css`
  font-family: 'Noto Sans', sans-serif;
  font-size: 13px;
  line-height: 16px;
`;

export const VerySmallTextStyle = css`
  font-family: 'Noto Sans', sans-serif;
  font-size: 10px;
  line-height: 16px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Dflex = Wrapper;

export const DFlexSpaceBetween = styled(Wrapper)`
  justify-content: space-between;
`;

export const hidePrintCss = css`
  @media print {
    & {
      display: none;
    }
  }
`;

export const PopoverHelpIconHover = styled(HelpIcon)`
  margin: -1px 0 0 4.6px;
  display: inline-flex;
  position: absolute;
  cursor: pointer;

  ${hidePrintCss}
`;

export const PopoverDropIconHover = styled(DropIcon)`
  margin-right: 9px;
  cursor: pointer;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
`;
export const Col = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const showPrintCss = css`
  display: none;
  @media print {
    & {
      display: block;
    }
  }
`;

export const PrintButton = styled.button`
  width: fit-content;
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: fit-content;
  border: none;

  &:hover {
    background: ${({ theme }) => theme.colors.primaryHover};
  }
`;
